import { render, staticRenderFns } from "./MonochromePie.vue?vue&type=template&id=5bd90fa5&scoped=true&"
import script from "./MonochromePie.vue?vue&type=script&lang=js&"
export * from "./MonochromePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd90fa5",
  null
  
)

export default component.exports